import { ReactComponent } from "./error-triangle-fill.svg";

interface Props {
  props?: any;
  fill?: string;
}

const ErrorTriangleFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ErrorTriangleFillIcon;
